<template>
  <rui-drawer v-if="element"
              :caption="element.displayName"
              :overlay="false"
              @close="$emit('close')">
    <template #actions>
      <rui-button icon="notebook"
                  block
                  :caption="$t('js.elements.action_buttons.show_observations')"
                  @click="showObservations()" />
    </template>

    <element-content :element="element" />
  </rui-drawer>
</template>

<script>
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiDrawer from '@experiments-labs/rise_ui/src/components/Drawer/Drawer.vue'

import Element from '../../../classes/models/Element'

import ElementContent from './_ElementContent.vue'

export default {
  name: 'ElementDrawer',
  emits: [
    'close',
  ],
  components: { RuiButton, RuiDrawer, ElementContent },
  props: {
    element: { required: false, type: Element, default: null },
  },
  methods: {
    showObservations () {
      this.$emitBus('show-observations', this.$props.element)
    },
  },
}
</script>
